import React, { useEffect, useState } from 'react';

interface Props{
}
const TermsAndConditionsOfSaleContainer: React.FC<Props> = ({}) => {

  return (
   	<div className="legal" style={{padding: '1rem 0'}}>
		    <h1 style={{padding: '1rem 0'}} className="title">
		        Terms and Conditions of Sale
		    </h1>
		    <div>
		        <p>This Puppy Purchase Agreement ("Agreement") is made between PuppySpot Group, LLC, a Florida limited liability company ("PuppySpot"), and the individual purchasing the puppy pursuant to this Agreement ("Customer" and collectively, with PuppySpot, the "Parties") for the purchase of the puppy identified by the Parties (the "puppy").&nbsp; The Customer may also purchase products for the puppy ("Products")</p>
						<p>The puppy is sold as-is, and, other than as expressly set forth herein or in the <a href="/terms-and-conditions-of-guarantee"> Health Commitment </a>, the terms of which are incorporated herein by reference and are made a part of this Agreement, PuppySpot makes no representations, warranties, covenants, agreements or guarantees including, without limitation, those relating to disposition, conformation, size, weight, color or markings of the puppy.</p>
						<p>The following terms and conditions also apply to your purchase of the puppy from PuppySpot:</p>
						<p className="italic">NOTICE: THIS AGREEMENT INCLUDES A BINDING ARBITRATION CLAUSE AND A CLASS ACTION WAIVER, SET FORTH BELOW, WHICH AFFECT YOUR RIGHTS. PLEASE READ IT CAREFULLY.</p>
		    </div>
		    <div>
		        <h2 style={{padding: '1rem 0'}}>1.&nbsp; Puppy Value.</h2>
			<p>The value of the puppy for all purposes of this Agreement and PuppySpot's <a href="/terms-and-conditions-of-guarantee">&nbsp;Health Commitment&nbsp;</a> (the "Health Commitment"), is limited to the purchase price of the puppy (the "Purchase Price"), and does not include, as applicable, applied store credit, taxes, shipping costs, health certificate, veterinarian costs, shipping crate or any additional costs or expenses incurred or asserted by Customer in connection with the puppy.</p>
			<h2 style={{textAlign: 'left', padding: '1rem 0'}}>2. Code of Conduct.</h2>
			<p>All puppies are sold as pets. Customer agrees and acknowledges that Customer will not breed the puppy. Customer agrees to spay or neuter the puppy at an appropriate age, as determined in consultation with Customer's veterinarian. Customer further agrees to care for the puppy in a humane and responsible manner, including, but not limited to providing it with clean and adequate shelter, food, water and veterinary care. Customer agrees that the puppy shall reside inside his or her home, shall not be allowed to roam freely, and shall wear a collar with identification tags and any required license tags at all times.&nbsp; &nbsp;</p>
			<p>Following is PuppySpot’s Code of Conduct:</p>
			<ul>
			<li>Lifelong care of the dog. This means committing to the relationship for your dog’s entire life.</li>
			<li>Selecting a dog and breed that is suited to your home and lifestyle and avoiding impulsive decisions.&nbsp; You should be aware of common health problems associated with individual breeds, how to prevent them, and how to recognize their onset. Ensure that the rules of your housing allows for dog ownership.</li>
			<li>Recognize that owning a dog(s) requires an investment of time and money.Keeping only the type and number of dogs for which you can provide a healthy, positive and safe environment. This includes appropriate/healthy food, water, shelter, health care, bathing, grooming and companionship. You need to be able to feed the puppy throughout the day, take it outside for bathroom breaks, and teach it manners (e.g. sit/stay and walk on a leash).</li>
			<li>Purchase food, treats, a collar and leash, toys, grooming tools, and other things you’ll need in advance so that your dog or puppy’s transition into your home will be a smooth one.</li>
			<li>You and your family members should decide who will be responsible for food, water, walks,&nbsp;exercise, cleanup, and&nbsp;grooming.</li>
			<li>Move breakables or “chewables” to higher ground. Make electrical cords inaccessible to curious paws and noses. Block off any area of the house that’s off-limits. Block access to any house, garden plants, foods or medicines that are toxic to dogs.</li>
			<li>Make sure the yard is securely fenced or that you have a run for your dog. Your pup will need to be on a leash outdoors.</li>
			<li>If traveling with your dog, keep your dog safe in the car by using a crate or seat belt harness.</li>
			<li>Create a comfortable area — whether a&nbsp;crate, a&nbsp;dog bed, or a pile of blankets — for your dog to go to when he needs rest or privacy.</li>
			<li>Ensure socialization and appropriate training for your dog(s) to facilitate their well-being and the well-being of other animals and people.</li>
			<li>Prevent your dog(s) from negatively impacting other people, animals and the environment. This includes proper waste disposal, noise control, and not allowing dog(s) to stray or become feral.</li>
			<li>Provide frequent exercise and mental stimulation appropriate to your dog(s)' age, breed, and health status.</li>
			<li>Establish and maintain a veterinarian-client-patient relationship. Choose a veterinarian ahead of time, so you’ll be ready for a visit soon after your dog comes home. Give your vet copies of the dog’s health records, and set up a&nbsp;vaccination&nbsp;and check-up schedule.</li>
			<li>Provide preventive (e.g., vaccinations, parasite control) and therapeutic health care for the life of your dog(s) in consultation with, and as recommended by, your veterinarian.</li>
			<li>Ensure dogs are properly identified (i.e., tags or microchips) and that their registration information in associated databases is kept up-to-date</li>
			<li>Adhere to all laws, regulations and ordinances, including licensing and leash requirements.</li>
			<li>Help to manage overpopulation by controlling your dog(s)' reproduction through spaying/neutering your dog.</li>
			<li>Include your dogs in your planning for an emergency or disaster, including assembling an evacuation kit.Make arrangements for the care of your dog when or if you are unable to do so.</li>
			<li>Recognize declines in your dog(s)' quality of life and making decisions in consultation with your veterinarian regarding appropriate end-of-life care (e.g., palliative care, hospice, euthanasia).</li>
			</ul>
			<h2 style={{textAlign: 'left', padding: '1rem 0'}}>3. Registration Paperwork.</h2>
			<p>Registration papers will only be sent for registered puppies and may not be sent until such time as the puppy has been spayed or neutered. Registration papers for all registered puppies will be sent by regular mail typically within two to four weeks of PuppySpot receiving confirmation of spay or neuter and could take up to six months. Any costs to obtain new or renewal registration papers are the sole responsibility of Customer. If the papers are lost, PuppySpot will assist Customer in obtaining new papers at Customer's expense.</p>
			<h2 style={{padding: '1rem 0'}}>4. Website Information Provided by Breeders.</h2>
			<p>PuppySpot makes every commercially reasonable effort to provide accurate and up-to-date information on PuppySpot.shop (the "Website") regarding puppies sold through PuppySpot's network. Such information includes, but is not limited to, breed, gender, color, date of birth, weight, parents' weights and registration details. PuppySpot relies on its network of breeders to accurately post thousands of puppies on the Website and is not responsible for typographical or photographical errors.</p>
			<h2 style={{padding: '1rem 0'}}>5. Travel.</h2>
			<p><span data-contrast="none">The puppy will typically travel within 2-3 weeks of the effective date of this Agreement. Occasionally, a puppy may need additional time with its breeder before travel. The final determination of the travel date for the puppy is made by the puppy's breeder and the breeder's veterinarian, with the health of the puppy being the primary determining factor. Transportation of the puppy is generally arranged through PuppySpot and may include third parties in both arranging and delivery. Occasionally, there may be delays for numerous reasons, including, but not limited to, weather, temperature restrictions, logistics, mechanical failure or other unforeseen events. PuppySpot shall not be liable, directly or indirectly, for any delays, including, without limitation, those that may cause Customer inconvenience or financial loss, nor shall any delay be a valid cause for cancellation of Customer's purchase of the puppy. Customer understands and agrees that no refund shall be provided by PuppySpot and/or its affiliated breeders due to any airline/airport delays or cancellations of the puppy's flight, whether such travel is domestic or international. Customer is solely responsible for any required documentation, health reports, or vaccinations that may be necessary to transport the puppy into any country other than the United States or Canada. </span><span>&nbsp;</span></p>
			<h2 style={{padding: '1rem 0'}}>6. Cancellation by Customer.</h2>
			<div>
			<div>
			<p><span data-contrast="none">Until such time as Customer has received confirmation from PuppySpot or the puppy's breeder about the date upon which the puppy will be delivered, Customer may cancel purchase of the puppy by notifying PuppySpot. In the event Customer cancels the purchase, Customer understands and agrees that an administrative fee schedule will apply to that purchase based on the table laid out below. Customer and PuppySpot agree that these amounts are a fair and equitable amount for damages as it would be impossible to compute the exact extent of damages sustained by PuppySpot because of such cancellation. </span><span>&nbsp;</span></p>
			</div>
			<div>
			<div>
			<div aria-hidden="true" id="{46d78597-12bf-4394-add5-5ad613fcebfc}{106}"></div>
			<table style={{width: '771px', height: '250.156px'}} aria-rowcount={5} data-tablelook={1184} data-tablestyle="MsoNormalTable" border={1}>
			<tbody>
			<tr style={{height: "20.5938px"}} aria-rowindex={1} role="row">
			<td style={{width: "364.922px", height: "20.5938px"}} data-celllook="4369" role="rowheader">
			<div>
			<div>
			<p><strong><span data-contrast="none">Timeline </span><span>&nbsp;</span></strong></p>
			</div>
			</div>
			</td>
			<td style={{width: '375.078px', height: "20.5938px"}} data-celllook="4369" role="columnheader">
			<div>
			<div>
			<p><strong><span data-contrast="none">Refund Customer Is Entitled To </span><span>&nbsp;</span></strong></p>
			</div>
			</div>
			</td>
			</tr>
			<tr style={{height: '67.1875px'}} aria-rowindex={2} role="row">
			<td style={{width: '364.922px', height: '67.1875px'}} data-celllook="4369" role="rowheader">
			<div>
			<div>
			<p><span data-contrast="none">Puppy on hold prior to complete payment. Maximum hold time is 72 hrs to provide full payment </span><span>&nbsp;</span></p>
			</div>
			</div>
			</td>
			<td style={{width: '375.078px', height: "67.1875px"}} data-celllook="4369">
			<div>
			<div>
			<p><span data-contrast="none">Non-refundable deposit of 25% of total invoice* is retained by PuppySpot  </span><span>&nbsp;</span></p>
			</div>
			</div>
			</td>
			</tr>
			<tr style={{height: '47.5938px'}} aria-rowindex={3} role="row">
			<td style={{width: '364.922px', height: '47.5938px'}} data-celllook="4369" role="rowheader">
			<div>
			<div>
			<p><span data-contrast="none">Purchases cancelled in first 72 hrs after purchase </span><span>&nbsp;</span></p>
			</div>
			</div>
			</td>
			<td style={{width: '375.078px', height: '47.5938px'}} data-celllook="4369">
			<div>
			<div>
			<p><span data-contrast="none">75% of total invoice* is returned to the Customer </span><span>&nbsp;</span></p>
			</div>
			</div>
			</td>
			</tr>
			<tr style={{height: '47.5938px'}} aria-rowindex={4} role="row">
			<td style={{width: '364.922px', height: '47.5938px'}} data-celllook="4369" role="rowheader">
			<div>
			<div>
			<p><span data-contrast="none">Purchases cancelled after 72 hrs of purchase&nbsp;</span><span>&nbsp;</span></p>
			</div>
			</div>
			</td>
			<td style={{width: '375.078px', height: '47.5938px'}} data-celllook="4369">
			<div>
			<div>
			<p><span data-contrast="none">50% of total invoice* is returned to the Customer </span><span>&nbsp;</span></p>
			</div>
			</div>
			</td>
			</tr>
			<tr style={{height: '67.1875px'}} aria-rowindex={5} role="row">
			<td style={{width: '364.922px', height: '67.1875px'}} data-celllook="4369" role="rowheader">
			<div>
			<div>
			<p>  <span data-contrast="none">Purchases cancelled within 72 hrs prior to Arrival Date of puppy </span><span>&nbsp;</span></p>
			</div>
			</div>
			</td>
			<td style={{width: '375.078px', height: "67.1875px"}} data-celllook="4369">
			<div>
			<div>
			<p><span data-contrast="none">No refund is provided to the Customer**</span><span>&nbsp;</span></p>
			</div>
			</div>
			</td>
			</tr>
			</tbody>
			</table>
			</div>
			</div>
			<div>
			<p> <span data-contrast="none">* Total invoice refers to Puppy, Travel and Health Certificate and additional products purchased with your puppy, like our PupPack or any AKC packages.&nbsp; Calculation of the amount does not include any taxes or discounts.</span><span>&nbsp;</span></p>
			</div>
			<div>
			<p><span data-contrast="none">** Customer will have any taxes paid on invoice items not received returned to them.</span><span>&nbsp;</span></p>
			</div>
			</div>
			<h2 style={{padding: '1rem 0'}}>7. No Warranties.</h2>
			<div>
			<p><span data-contrast="none">PuppySpot disclaims any and all implied warranties of merchantability and fitness. PuppySpot further specifically disclaims any liability related to the appearance, temperament, personality, size, weight, color, compatibility with breed standards or DNA test results of any puppy. PuppySpot does not warrant the accuracy or completeness of the Products.</span><span>&nbsp;</span></p>
			</div>
			<div>
			<p><span data-contrast="none">Additionally, while each PuppySpot puppy undergoes a Nose-to-Tail exam as part of obtaining the Health Certificate, there are many common conditions that will still permit a puppy to travel.  Many of these conditions listed in Table 7.1 below are either considered Normal for Breed (for more on this topic, please reference section 10 below – Understanding the Breed You are getting) or are covered as part of our </span><a rel="noreferrer noopener" target="_blank" href="/terms-and-conditions-of-commitment"><span data-contrast="none">Health Commitment </span></a><span data-contrast="none"> should they remain present upon arrival to the Customer. </span><span>&nbsp;</span></p>
			</div>
			<div>
			<div>
			<div aria-hidden="true" id="{b457e8f3-96ec-4ed1-a277-02189d5b58ce}{97}"></div>
			<table aria-rowcount={6} data-tablelook={1184} data-tablestyle="MsoNormalTable" border={1} style={{borderCollapse: 'collapse', width: '861px', height: '360px', borderWidth: '1px', borderSpacing: '6px'}}>
			<tbody>
			<tr style={{height: '51.6797px'}} aria-rowindex={1} role="row">
			<td style={{width: '186.188px', height: "51.6797px", borderWidth: '1px', padding: '6px'}} data-celllook="0" role="rowheader">
			<div>
			<div>
			<p><span data-contrast="none">Bite Issues</span><span>&nbsp;</span></p>
			</div>
			</div>
			</td>
			<td style={{width: '211.047px', height: '51.6797px', borderWidth: '1px', padding: '6px'}} data-celllook="0" role="columnheader">
			<div>
			<div>
			<p> <span data-contrast="none">Coccidia</span><span>&nbsp;</span></p>
			</div>
			</div>
			</td>
			<td style={{width: '205.641px', height: '51.6797px', borderWidth: '1px', padding: '6px'}} data-celllook="0" role="columnheader">
			<div>
			<div>
			<p> <span data-contrast="none">Spayed</span><span>&nbsp;</span></p>
			</div>
			</div>
			</td>
			<td style={{width: '197.125px', height: '51.6797px', borderWidth: '1px', padding: '6px'}} data-celllook="0" role="columnheader">
			<div>
			<div>
			<p> <span data-contrast="none">Ticks</span><span>&nbsp;</span></p>
			</div>
			</div>
			</td>
			</tr>
			<tr style={{height: '51.6797px'}} aria-rowindex={2} role="row">
			<td style={{width: '186.188px', height: "51.6797px", borderWidth: '1px', padding: '6px'}} data-celllook="0" role="rowheader">
			<div>
			<div>
			<p> <span data-contrast="none">Body Condition Score between 3 -8</span><span>&nbsp;</span></p>
			</div>
			</div>
			</td>
			<td style={{width: '211.047px', height: '51.6797px', borderWidth: '1px', padding: '6px'}} data-celllook="0">
			<div>
			<div>
			<p> <span data-contrast="none">Giardia</span><span>&nbsp;</span></p>
			</div>
			</div>
			</td>
			<td style={{width: '205.641px', height: '51.6797px', borderWidth: '1px', padding: '6px'}} data-celllook="0">
			<div>
			<div>
			<p><span data-contrast="none">Neutered</span><span>&nbsp;</span></p>
			</div>
			</div>
			</td>
			<td style={{width: '197.125px', height: '51.6797px', borderWidth: '1px', padding: '6px'}} data-celllook="0">
			<div>
			<div>
			<p> <span data-contrast="none">Fleas</span><span>&nbsp;</span></p>
			</div>
			</div>
			</td>
			</tr>
			<tr style={{height: '51.6797px'}} aria-rowindex={3} role="row">
			<td style={{width: '186.188px', height: "51.6797px", borderWidth: '1px', padding: '6px'}} data-celllook="0" role="rowheader">
			<div>
			<div>
			<p> <span data-contrast="none">Ear Debris</span><span>&nbsp;</span></p>
			</div>
			</div>
			</td>
			<td style={{width: '211.047px', height: '51.6797px', borderWidth: '1px', padding: '6px'}} data-celllook="0">
			<div>
			<div>
			<p><span data-contrast="none">Normal For Breed underbite</span><span>&nbsp;</span></p>
			</div>
			</div>
			</td>
			<td style={{width: '205.641px', height: '51.6797px', borderWidth: '1px', padding: '6px'}} data-celllook="0">
			<div>
			<div>
			<p><span data-contrast="none">Hernia/Hernia Repair</span><span>&nbsp;</span></p>
			</div>
			</div>
			</td>
			<td style={{width: '197.125px', height: '51.6797px', borderWidth: '1px', padding: '6px'}} data-celllook="0">
			<div>
			<div>
			<p> <span data-contrast="none">Hookworms</span><span>&nbsp;</span></p>
			</div>
			</div>
			</td>
			</tr>
			<tr style={{height: '51.6797px'}} aria-rowindex={4} role="row">
			<td style={{width: '186.188px', height: "51.6797px", borderWidth: '1px', padding: '6px'}} data-celllook="0" role="rowheader">
			<div>
			<div>
			<p> <span data-contrast="none">Ear Discharge</span><span>&nbsp;</span></p>
			</div>
			</div>
			</td>
			<td style={{width: '211.047px', height: '51.6797px', borderWidth: '1px', padding: '6px'}} data-celllook="0">
			<div>
			<div>
			<p><span data-contrast="none">Stenotic Nares/Stenotic Nares Repaired</span><span>&nbsp;</span></p>
			</div>
			</div>
			</td>
			<td style={{width: '205.641px', height: '51.6797px', borderWidth: '1px', padding: '6px'}} data-celllook="0">
			<div>
			<div>
			<p> <span data-contrast="none">Tail Docked</span><span>&nbsp;</span></p>
			</div>
			</div>
			</td>
			<td style={{width: '197.125px', height: '51.6797px', borderWidth: '1px', padding: '6px'}} data-celllook="0">
			<div>
			<div>
			<p><span data-contrast="none">Tapeworms</span><span>&nbsp;</span></p>
			</div>
			</div>
			</td>
			</tr>
			<tr style={{height: '51.6797px'}} aria-rowindex={5} role="row">
			<td style={{width: '186.188px', height: "51.6797px", borderWidth: '1px', padding: '6px'}} data-celllook="0" role="rowheader">
			<div>
			<div>
			<p> <span data-contrast="none">Ear Mites</span><span>&nbsp;</span></p>
			</div>
			</div>
			</td>
			<td style={{width: '211.047px', height: '51.6797px', borderWidth: '1px', padding: '6px'}} data-celllook="0">
			<div>
			<div>
			<p><span data-contrast="none">Ear Cropping</span><span>&nbsp;</span></p>
			</div>
			</div>
			</td>
			<td style={{width: '205.641px', height: '51.6797px', borderWidth: '1px', padding: '6px'}} data-celllook="0">
			<div>
			<div>
			<p><span data-contrast="none">Dew Claw Removed</span><span>&nbsp;</span></p>
			</div>
			</div>
			</td>
			<td style={{width: '197.125px', height: '51.6797px', borderWidth: '1px', padding: '6px'}} data-celllook="0">
			<div>
			<div>
			<p><span data-contrast="none">Whipworm</span><span>&nbsp;</span></p>
			</div>
			</div>
			</td>
			</tr>
			<tr style={{height: "25.6016px"}} aria-rowindex={6} role="row">
			<td style={{width: '186.188px', height: '25.6016px', borderWidth: '1px', padding: '6px'}} data-celllook="0" role="rowheader"></td>
			<td style={{width: '211.047px', height: '25.6016px', borderWidth: '1px', padding: '6px'}} data-celllook="0">
			<div>
			<div>
			<p> <span data-contrast="none">Undescended Testicles</span><span>&nbsp;</span></p>
			</div>
			</div>
			</td>
			<td style={{width: '205.641px', height: '25.6016px', borderWidth: '1px', padding: '6px'}} data-celllook="0">
			<div>
			<div>
			<p><span data-contrast="none">Open fontanel under 1 cm</span><span>&nbsp;</span></p>
			</div>
			</div>
			</td>
			<td style={{width: '197.125px', height: '25.6016px', borderWidth: '1px', padding: '6px'}} data-celllook="0"></td>
			</tr>
			</tbody>
			</table>
			</div>
			</div>
			<p><span data-contrast="none">If there are more serious items, PuppySpot will make every reasonable attempt to contact the Customer to inform them of said condition and discuss options.  For more information about many common health conditions faced by new puppy owners, please </span><a rel="noreferrer noopener" target="_blank" href="https://support.puppyspot.shop/"><span data-contrast="none">read about them in our Help Center</span></a><span data-contrast="none">.</span><span>&nbsp;</span></p>
			<h2 style={{padding: '1rem 0'}}>8. No Returns for Monetary Refund.</h2>
			<p>PuppySpot will not accept any returns of the puppy for monetary refund for any reason including, without limitation, allergies, landlord/tenant restrictions, marital issues, puppy adjustment problems or any other reason. Puppies need time to adjust to their new surroundings – before deciding your puppy isn't working out, give us a call here at PuppySpot so we can help you figure out if any discomfort you or your puppy are having is routine adjustment or something bigger.</p>
			<h2 style={{padding: '1rem 0'}}>9. Puppy Must Be Returned If Customer Cannot Care for It.</h2>
			<p>In the event Customer is unable or unwilling to care for the puppy at any time during the puppy's life, Customer agrees to contact PuppySpot immediately regarding rehoming the puppy. If Customer must return the puppy for any reason, it will be on a surrender basis only with no refund or credit, and Customer will be responsible for all travel-related costs. Upon any such surrender, PuppySpot shall use commercially reasonable efforts to find a new home for the puppy through PuppySpot's proprietary rehoming program.</p>
			<div>
			<div>
			<h2 style={{padding: '1rem 0'}}> <span data-contrast="none">10. Understanding the Breed You Are Getting.<span>&nbsp;</span></span></h2>
			<p><span data-contrast="none">There are many breeds of dog which have characteristics, both physical and temperament, that make them the breeds that they are.  We recommend the Customer become very acquainted with what those may be.  While by no means a complete list the American Kennel Club maintains a directory all the breeds they recognize.  We strongly recommend the Customer access this directory at </span><a rel="noreferrer noopener" target="_blank" href="https://www.akc.org/dog-breeds/"><span data-contrast="none">https://www.akc.org/dog-breeds/</span></a><span data-contrast="none"> for the breed of puppy that they are getting.</span><span>&nbsp;</span></p>
			</div>
			<div>
			<p><span data-contrast="none">In addition, PuppySpot does not warrant health issues or surrenders for any of the following breed groups where conditions that are considered Normal For Breed may be present.</span><span>&nbsp;</span></p>
			</div>
			<div>
			<p><strong><span data-contrast="none">Brachycephalic Breeds</span><span>&nbsp;</span></strong></p>
			</div>
			<div>
			<ul style={{listStyleType: 'disc'}} role="list">
			<li role="listitem" data-aria-level={1} data-aria-posinset={1} aria-setsize={-1} data-list-defn-props="{&quot;335552541&quot;:1,&quot;335559684&quot;:-2,&quot;335559685&quot;:720,&quot;335559991&quot;:360,&quot;469769226&quot;:&quot;Symbol&quot;,&quot;469769242&quot;:[8226],&quot;469777803&quot;:&quot;left&quot;,&quot;469777804&quot;:&quot;&quot;,&quot;469777815&quot;:&quot;multilevel&quot;}" data-listid="2" data-font="Symbol" data-leveltext="">
			<p><span data-contrast="none">Brachy - Comes from a Greek word meaning “short”</span><span data-ccp-props="{&quot;134233117&quot;:true,&quot;134233118&quot;:true,&quot;201341983&quot;:0,&quot;335559685&quot;:960,&quot;335559737&quot;:240,&quot;335559739&quot;:160,&quot;335559740&quot;:240}">&nbsp;</span></p>
			</li>
			</ul>
			</div>
			</div>
			<div>
			<div>
			<ul style={{listStyleType: 'disc'}} role="list">
			<li role="listitem" data-aria-level={1} data-aria-posinset={1} aria-setsize={-1} data-list-defn-props="{&quot;335552541&quot;:1,&quot;335559684&quot;:-2,&quot;335559685&quot;:720,&quot;335559991&quot;:360,&quot;469769226&quot;:&quot;Symbol&quot;,&quot;469769242&quot;:[8226],&quot;469777803&quot;:&quot;left&quot;,&quot;469777804&quot;:&quot;&quot;,&quot;469777815&quot;:&quot;multilevel&quot;}" data-listid="2" data-font="Symbol" data-leveltext="">
			<p><span data-contrast="none">Cephalic - Of or relating to the head</span><span data-ccp-props="{&quot;134233117&quot;:true,&quot;134233118&quot;:true,&quot;201341983&quot;:0,&quot;335559685&quot;:960,&quot;335559737&quot;:240,&quot;335559739&quot;:160,&quot;335559740&quot;:240}">&nbsp;</span></p>
			</li>
			</ul>
			</div>
			<div>
			<p><span data-contrast="none">Dogs that are flat faced with short, round heads are known as brachycephalic breeds. Their skull bones are shortened in length, giving their face a pushed in appearance. It is recommended that brachycephalic breeds should be walked during cool times of the day and preferably on a harness. They are never to be outside dogs. These breeds sometimes require a simple stenotic nares surgery to open the nasal passages.  Any puppy that is a mix with any of these breeds would also be considered brachycephalic for the purpose of this agreement.</span><span>&nbsp;</span></p>
			</div>
			</div>
			<div>
			<div>
			<div aria-hidden="true" id="{6fdd59ae-f916-4bde-bb5f-a7aaaca9a8bd}{158}"></div>
			<table aria-rowcount={8} data-tablelook={1184} data-tablestyle="MsoNormalTable" border={1} style={{borderCollapse: 'collapse', width: '682px', height: '424px', borderWidth: '1px', borderSpacing: '6px'}}>
			<tbody>
			<tr style={{height: "18px"}} aria-rowindex={1} role="row">
			<td style={{width: '217.695px', borderWidth: '1px', padding: '6px'}} data-celllook="4369" role="rowheader">
			<div>
			<div>
			<p><span data-contrast="auto">Affenpinscher</span><span data-ccp-props="{&quot;201341983&quot;:0,&quot;335559738&quot;:360,&quot;335559739&quot;:360,&quot;335559740&quot;:240}">&nbsp;</span></p>
			</div>
			</div>
			</td>
			<td style={{width: '196.188px', borderWidth: '1px', padding: '6px'}} data-celllook="4369" role="columnheader">
			<div>
			<div>
			<p> <span data-contrast="auto">Cane Corso</span><span data-ccp-props="{&quot;201341983&quot;:0,&quot;335559738&quot;:360,&quot;335559739&quot;:360,&quot;335559740&quot;:240}">&nbsp;</span></p>
			</div>
			</div>
			</td>
			<td style={{width: '222.117px', borderWidth: '1px', padding: '6px'}} data-celllook="4369" role="columnheader">
			<div>
			<div>
			<p><span data-contrast="auto">Lhasa Apso</span><span data-ccp-props="{&quot;201341983&quot;:0,&quot;335559738&quot;:360,&quot;335559739&quot;:360,&quot;335559740&quot;:240}">&nbsp;</span></p>
			</div>
			</div>
			</td>
			</tr>
			<tr style={{height: "18px"}} aria-rowindex={2} role="row">
			<td style={{width: '217.688px', borderWidth: '1px', padding: '6px'}} data-celllook="4369" role="rowheader">
			<div>
			<div>
			<p><span data-contrast="auto">American Bulldog</span><span data-ccp-props="{&quot;201341983&quot;:0,&quot;335559738&quot;:360,&quot;335559739&quot;:360,&quot;335559740&quot;:240}">&nbsp;</span></p>
			</div>
			</div>
			</td>
			<td style={{width: '196.188px', borderWidth: '1px', padding: '6px'}} data-celllook="4369">
			<div>
			<div>
			<p> <span data-contrast="auto">Cavalier King Charles Spaniel</span><span data-ccp-props="{&quot;201341983&quot;:0,&quot;335559738&quot;:360,&quot;335559739&quot;:360,&quot;335559740&quot;:240}">&nbsp;</span></p>
			</div>
			</div>
			</td>
			<td style={{width: '222.125px', borderWidth: '1px', padding: '6px;'}} data-celllook="4369">
			<div>
			<div>
			<p><span data-contrast="auto">Mastiff</span><span data-ccp-props="{&quot;201341983&quot;:0,&quot;335559738&quot;:360,&quot;335559739&quot;:360,&quot;335559740&quot;:240}">&nbsp;</span></p>
			</div>
			</div>
			</td>
			</tr>
			<tr style={{height: "18px"}} aria-rowindex={3} role="row">
			<td style={{width: '217.688px', borderWidth: '1px', padding: '6px'}} data-celllook="4369" role="rowheader">
			<div>
			<div>
			<p><span data-contrast="auto">American Staffordshire Terrier</span><span data-ccp-props="{&quot;201341983&quot;:0,&quot;335559738&quot;:360,&quot;335559739&quot;:360,&quot;335559740&quot;:240}">&nbsp;</span></p>
			</div>
			</div>
			</td>
			<td style={{width: '196.188px', borderWidth: '1px', padding: '6px'}} data-celllook="4369">
			<div>
			<div>
			<p> <span data-contrast="auto">Chihuahua (apple head)</span><span data-ccp-props="{&quot;201341983&quot;:0,&quot;335559738&quot;:360,&quot;335559739&quot;:360,&quot;335559740&quot;:240}">&nbsp;</span></p>
			</div>
			</div>
			</td>
			<td style={{width: '222.125px', borderWidth: '1px', padding: '6px;'}} data-celllook="4369">
			<div>
			<div>
			<p><span data-contrast="auto">Neapolitan Mastiff</span><span data-ccp-props="{&quot;201341983&quot;:0,&quot;335559738&quot;:360,&quot;335559739&quot;:360,&quot;335559740&quot;:240}">&nbsp;</span></p>
			</div>
			</div>
			</td>
			</tr>
			<tr style={{height: "18px"}} aria-rowindex={4} role="row">
			<td style={{width: '217.688px', borderWidth: '1px', padding: '6px'}} data-celllook="4369" role="rowheader">
			<div>
			<div>
			<p><span data-contrast="auto">Boston Terrier</span><span data-ccp-props="{&quot;201341983&quot;:0,&quot;335559738&quot;:360,&quot;335559739&quot;:360,&quot;335559740&quot;:240}">&nbsp;</span></p>
			</div>
			</div>
			</td>
			<td style={{width: '196.188px', borderWidth: '1px', padding: '6px'}} data-celllook="4369">
			<div>
			<div>
			<p><span data-contrast="auto">Chinese Shar-Pei (heavily wrinkeld)</span><span data-ccp-props="{&quot;201341983&quot;:0,&quot;335559738&quot;:360,&quot;335559739&quot;:360,&quot;335559740&quot;:240}">&nbsp;</span></p>
			</div>
			</div>
			</td>
			<td style={{width: '222.125px', borderWidth: '1px', padding: '6px;'}} data-celllook="4369">
			<div>
			<div>
			<p> <span data-contrast="auto">Newfoundland</span><span data-ccp-props="{&quot;201341983&quot;:0,&quot;335559738&quot;:360,&quot;335559739&quot;:360,&quot;335559740&quot;:240}">&nbsp;</span></p>
			</div>
			</div>
			</td>
			</tr>
			<tr style={{height: "18px"}} aria-rowindex={5} role="row">
			<td style={{width: '217.688px', borderWidth: '1px', padding: '6px'}} data-celllook="4369" role="rowheader">
			<div>
			<div>
			<p><span data-contrast="auto">Boxer</span><span data-ccp-props="{&quot;201341983&quot;:0,&quot;335559738&quot;:360,&quot;335559739&quot;:360,&quot;335559740&quot;:240}">&nbsp;</span></p>
			</div>
			</div>
			</td>
			<td style={{width: '196.188px', borderWidth: '1px', padding: '6px'}} data-celllook="4369">
			<div>
			<div>
			<p><span data-contrast="auto">Chow Chow</span><span data-ccp-props="{&quot;201341983&quot;:0,&quot;335559738&quot;:360,&quot;335559739&quot;:360,&quot;335559740&quot;:240}">&nbsp;</span></p>
			</div>
			</div>
			</td>
			<td style={{width: '222.125px', borderWidth: '1px', padding: '6px;'}} data-celllook="4369">
			<div>
			<div>
			<p> <span data-contrast="auto">Pekingese</span><span data-ccp-props="{&quot;201341983&quot;:0,&quot;335559738&quot;:360,&quot;335559739&quot;:360,&quot;335559740&quot;:240}">&nbsp;</span></p>
			</div>
			</div>
			</td>
			</tr>
			<tr style={{height: "18px"}} aria-rowindex={6} role="row">
			<td style={{width: '217.688px', borderWidth: '1px', padding: '6px'}} data-celllook="4369" role="rowheader">
			<div>
			<div>
			<p> <span data-contrast="auto">Brussels Griffon</span><span data-ccp-props="{&quot;201341983&quot;:0,&quot;335559738&quot;:360,&quot;335559739&quot;:360,&quot;335559740&quot;:240}">&nbsp;</span></p>
			</div>
			</div>
			</td>
			<td style={{width: '196.188px', borderWidth: '1px', padding: '6px'}} data-celllook="4369">
			<div>
			<div>
			<p><span data-contrast="auto">Dogo Argentino</span><span data-ccp-props="{&quot;201341983&quot;:0,&quot;335559738&quot;:360,&quot;335559739&quot;:360,&quot;335559740&quot;:240}">&nbsp;</span></p>
			</div>
			</div>
			</td>
			<td style={{width: '222.125px', borderWidth: '1px', padding: '6px;'}} data-celllook="4369">
			<div>
			<div>
			<p> <span data-contrast="auto">Pug</span><span data-ccp-props="{&quot;201341983&quot;:0,&quot;335559738&quot;:360,&quot;335559739&quot;:360,&quot;335559740&quot;:240}">&nbsp;</span></p>
			</div>
			</div>
			</td>
			</tr>
			<tr style={{height: "18px"}} aria-rowindex={7} role="row">
			<td style={{width: '217.688px', borderWidth: '1px', padding: '6px'}} data-celllook="4369" role="rowheader">
			<div>
			<div>
			<p><span data-contrast="auto">Bull Mastiff</span><span data-ccp-props="{&quot;201341983&quot;:0,&quot;335559738&quot;:360,&quot;335559739&quot;:360,&quot;335559740&quot;:240}">&nbsp;</span></p>
			</div>
			</div>
			</td>
			<td style={{width: '196.188px', borderWidth: '1px', padding: '6px'}} data-celllook="4369">
			<div>
			<div>
			<p><span data-contrast="auto">French Bulldog</span><span data-ccp-props="{&quot;201341983&quot;:0,&quot;335559738&quot;:360,&quot;335559739&quot;:360,&quot;335559740&quot;:240}">&nbsp;</span></p>
			</div>
			</div>
			</td>
			<td style={{width: '222.125px', borderWidth: '1px', padding: '6px;'}} data-celllook="4369">
			<div>
			<div>
			<p><span data-contrast="auto">Shih Tzu</span><span data-ccp-props="{&quot;201341983&quot;:0,&quot;335559738&quot;:360,&quot;335559739&quot;:360,&quot;335559740&quot;:240}">&nbsp;</span></p>
			</div>
			</div>
			</td>
			</tr>
			<tr style={{height: "18px"}} aria-rowindex={8} role="row">
			<td style={{width: '217.688px', borderWidth: '1px', padding: '6px'}} data-celllook="4369" role="rowheader">
			<div>
			<div>
			<p><span data-contrast="auto">Bulldog</span><span data-ccp-props="{&quot;201341983&quot;:0,&quot;335559738&quot;:360,&quot;335559739&quot;:360,&quot;335559740&quot;:240}">&nbsp;</span></p>
			</div>
			</div>
			</td>
			<td style={{width: '196.188px', borderWidth: '1px', padding: '6px'}} data-celllook="4369">
			<div>
			<div>
			<p><span data-contrast="auto">Japanese Chin</span><span data-ccp-props="{&quot;201341983&quot;:0,&quot;335559738&quot;:360,&quot;335559739&quot;:360,&quot;335559740&quot;:240}">&nbsp;</span></p>
			</div>
			</div>
			</td>
			<td style={{width: '222.125px', borderWidth: '1px', padding: '6px;'}} data-celllook="4369">
			<div>
			<div>
			<p><span data-contrast="auto">Yorkshire Terrier (short muzzled)</span><span data-ccp-props="{&quot;201341983&quot;:0,&quot;335559738&quot;:360,&quot;335559739&quot;:360,&quot;335559740&quot;:240}">&nbsp;</span></p>
			</div>
			</div>
			</td>
			</tr>
			</tbody>
			</table>
			</div>
			</div>
			<div>
			<p><span data-contrast="none">In addition to these care guidelines, puppies considered brachycephalic may also be refused Pet Safe Commercial Air travel and face other travel restrictions for traveling on commercial airlines.</span><span>&nbsp;</span></p>
			</div>
			<div>
			<p><strong><span data-contrast="none">Breeds with Underbites</span><span>&nbsp;</span></strong></p>
			</div>
			<div>
			<p><span data-contrast="none">An underbite is when a dog’s bottom jaw does not align with the top. The lower jaw extends further out causing a gap between the teeth. Although this is a hereditary condition, there are certain breeds that this is considered a breed standard as well as any designer breeds created from a mix with these breeds.</span><span>&nbsp;</span></p>
			</div>
			<div>
			<div>
			<div aria-hidden="true" id="{6fdd59ae-f916-4bde-bb5f-a7aaaca9a8bd}{159}"></div>
			<table aria-rowcount={6} data-tablelook={1184} data-tablestyle="MsoNormalTable" border={1} style={{borderCollapse: 'collapse', width: '371px', height: '327px', borderWidth: '1px', borderSpacing: '6px'}}>
			<tbody>
			<tr style={{height: "20px"}} aria-rowindex={1} role="row">
			<td style={{width: '177.766px', borderWidth: '1px', padding: '6px'}} data-celllook="4369" role="rowheader">
			<div>
			<div>
			<p><span data-contrast="auto">Lhasa Apso</span><span data-ccp-props="{&quot;201341983&quot;:0,&quot;335559738&quot;:360,&quot;335559739&quot;:360,&quot;335559740&quot;:240}">&nbsp;</span></p>
			</div>
			</div>
			</td>
			<td style={{width: '162.234px', borderWidth: '1px', padding: '6px'}} data-celllook="4369" role="columnheader">
			<div>
			<div>
			<p><span data-contrast="auto">Boxer</span><span data-ccp-props="{&quot;201341983&quot;:0,&quot;335559738&quot;:360,&quot;335559739&quot;:360,&quot;335559740&quot;:240}">&nbsp;</span></p>
			</div>
			</div>
			</td>
			</tr>
			<tr style={{height: "20px"}} aria-rowindex={2} role="row">
			<td style={{width: '177.766px', borderWidth: '1px', padding: '6px'}} data-celllook="4369" role="rowheader">
			<div>
			<div>
			<p><span data-contrast="auto">Pekingese</span><span data-ccp-props="{&quot;201341983&quot;:0,&quot;335559738&quot;:360,&quot;335559739&quot;:360,&quot;335559740&quot;:240}">&nbsp;</span></p>
			</div>
			</div>
			</td>
			<td style={{width: '162.234px', borderWidth: '1px', padding: '6px'}} data-celllook="4369">
			<div>
			<div>
			<p><span data-contrast="auto">Brussels Griffon</span><span data-ccp-props="{&quot;201341983&quot;:0,&quot;335559738&quot;:360,&quot;335559739&quot;:360,&quot;335559740&quot;:240}">&nbsp;</span></p>
			</div>
			</div>
			</td>
			</tr>
			<tr style={{height: "20px"}} aria-rowindex={3} role="row">
			<td style={{width: '177.766px', borderWidth: '1px', padding: '6px'}} data-celllook="4369" role="rowheader">
			<div>
			<div>
			<p><span data-contrast="auto">Pug</span><span data-ccp-props="{&quot;201341983&quot;:0,&quot;335559738&quot;:360,&quot;335559739&quot;:360,&quot;335559740&quot;:240}">&nbsp;</span></p>
			</div>
			</div>
			</td>
			<td style={{width: '162.234px', borderWidth: '1px', padding: '6px'}} data-celllook="4369">
			<div>
			<div>
			<p><span data-contrast="auto">Bulldog</span><span data-ccp-props="{&quot;201341983&quot;:0,&quot;335559738&quot;:360,&quot;335559739&quot;:360,&quot;335559740&quot;:240}">&nbsp;</span></p>
			</div>
			</div>
			</td>
			</tr>
			<tr style={{height: "20px"}} aria-rowindex={4} role="row">
			<td style={{width: '177.766px', borderWidth: '1px', padding: '6px'}} data-celllook="4369" role="rowheader">
			<div>
			<div>
			<p><span data-contrast="auto">Puggle</span><span data-ccp-props="{&quot;201341983&quot;:0,&quot;335559738&quot;:360,&quot;335559739&quot;:360,&quot;335559740&quot;:240}">&nbsp;</span></p>
			</div>
			</div>
			</td>
			<td style={{width: '162.234px', borderWidth: '1px', padding: '6px'}} data-celllook="4369">
			<div>
			<div>
			<p><span data-contrast="auto">French Bulldog</span><span data-ccp-props="{&quot;201341983&quot;:0,&quot;335559738&quot;:360,&quot;335559739&quot;:360,&quot;335559740&quot;:240}">&nbsp;</span></p>
			</div>
			</div>
			</td>
			</tr>
			<tr style={{height: "20px"}} aria-rowindex={5} role="row">
			<td style={{width: '177.766px', borderWidth: '1px', padding: '6px'}} data-celllook="4369" role="rowheader">
			<div>
			<div>
			<p> <span data-contrast="auto">Boston Terrier</span><span data-ccp-props="{&quot;201341983&quot;:0,&quot;335559738&quot;:360,&quot;335559739&quot;:360,&quot;335559740&quot;:240}">&nbsp;</span></p>
			</div>
			</div>
			</td>
			<td style={{width: '162.234px', borderWidth: '1px', padding: '6px'}} data-celllook="4369">
			<div>
			<div>
			<p><span data-contrast="auto">Shih Tzu</span><span data-ccp-props="{&quot;201341983&quot;:0,&quot;335559738&quot;:360,&quot;335559739&quot;:360,&quot;335559740&quot;:240}">&nbsp;</span></p>
			</div>
			</div>
			</td>
			</tr>
			<tr style={{height: "20px"}} aria-rowindex={6} role="row">
			<td style={{width: '177.766px', borderWidth: '1px', padding: '6px'}} data-celllook="4369" role="rowheader">
			<div>
			<div>
			<p><span data-contrast="auto">English Bulldog</span><span data-ccp-props="{&quot;201341983&quot;:0,&quot;335559738&quot;:360,&quot;335559739&quot;:360,&quot;335559740&quot;:240}">&nbsp;</span></p>
			</div>
			</div>
			</td>
			<td style={{width: '162.234px', borderWidth: '1px', padding: '6px'}} data-celllook="4369">
			<div>
			<div>
			<p> <span data-contrast="auto"></span><span data-ccp-props="{&quot;201341983&quot;:0,&quot;335559738&quot;:360,&quot;335559739&quot;:360,&quot;335559740&quot;:240}">&nbsp;</span></p>
			</div>
			</div>
			</td>
			</tr>
			</tbody>
			</table>
			</div>
			</div>
			<div>
			<p><strong><span data-contrast="none">Open Fontanelle </span><span>&nbsp;</span></strong></p>
			</div>
			<div>
			<p><span data-contrast="none">Open fontanelles are soft spots in the skull, or gaps between the skull’s growth plates, much like a newborn baby. They can be normal in young puppies, especially small breeds, but they typically close or harden by 9-12 weeks of age. In some breeds, such as Chihuahuas, Miniature Dachshunds, Pomeranians, Shih Tzus, Yorkshire Terriers, Maltese, Lhasa Apsos, and Pekingese it is considered to be part of the breed standard and therefore not uncommon for open fontanelles to persist beyond 12 weeks of age. In fact, open fontanelles in Chihuahuas are referred to as “moleras” and they are considered to be part of the breed standard, along with the classic dome-shaped skull. </span><span>&nbsp;</span></p>
			</div>
			<div>
			<p> <span data-contrast="none">Open fontanelles do not typically cause problems for affected dogs. In theory, the soft spot in the skull could make your puppy more susceptible to brain injury in the event of a blow to the head. However, this is uncommon and dogs with persistent open fontanelles typically live normal, healthy lives. </span><span>&nbsp;</span></p>
			</div>
			<div>
			<p> <strong><span data-contrast="none"> </span><span data-contrast="none">Heterochromia </span><span>&nbsp;</span></strong></p>
			</div>
			<div>
			<p><span data-contrast="none">Heterochromia at its most fundamental is a condition where each eye is a different color either in whole or part. This is caused by a melanin imbalance – either too much (hyperchromic) melanin or too little (hypochromic) melanin.</span><span>&nbsp;</span></p>
			</div>
			<div>
			<p><span data-contrast="none">Genetic studies along with breeder and dog owner reports to date tell us that these dog breeds are more likely to produce puppies with different colored eyes:</span><span>&nbsp;</span></p>
			</div>
			<div>
			<div>
			<div aria-hidden="true" id="{6fdd59ae-f916-4bde-bb5f-a7aaaca9a8bd}{160}"></div>
			<table aria-rowcount={7} data-tablelook={1184} data-tablestyle="MsoNormalTable" border={1} style={{borderCollapse: 'collapse', width: '353px', height: '333.157px', borderWidth: '1px', borderSpacing: '6px'}}>
			<tbody>
			<tr style={{height: '47.5938px'}} aria-rowindex={1} role="row">
			<td style={{width: '157.125px', borderWidth: '1px', height: '47.5938px', padding: '6px'}} data-celllook="4369" role="rowheader">
			<div>
			<div>
			<p> <span data-contrast="auto">Huskies</span><span data-ccp-props="{&quot;201341983&quot;:0,&quot;335559738&quot;:360,&quot;335559739&quot;:360,&quot;335559740&quot;:240}">&nbsp;</span></p>
			</div>
			</div>
			</td>
			<td style={{width: '164.875px', borderWidth: '1px', height: '47.5938px', padding: '6px'}} data-celllook="4369" role="columnheader">
			<div>
			<div>
			<p><span data-contrast="auto">Welsh Corgis</span><span data-ccp-props="{&quot;201341983&quot;:0,&quot;335559738&quot;:360,&quot;335559739&quot;:360,&quot;335559740&quot;:240}">&nbsp;</span></p>
			</div>
			</div>
			</td>
			</tr>
			<tr style={{height: '47.5938px'}} aria-rowindex={2} role="row">
			<td style={{width: '157.125px', borderWidth: '1px', height: '47.5938px', padding: '6px'}} data-celllook="4369" role="rowheader">
			<div>
			<div>
			<p><span data-contrast="auto">Shetland Sheepdog</span><span data-ccp-props="{&quot;201341983&quot;:0,&quot;335559738&quot;:360,&quot;335559739&quot;:360,&quot;335559740&quot;:240}">&nbsp;</span></p>
			</div>
			</div>
			</td>
			<td style={{width: '164.875px', borderWidth: '1px', height: '47.5938px', padding: '6px'}} data-celllook="4369">
			<div>
			<div>
			<p> <span data-contrast="auto">Great Danes</span><span data-ccp-props="{&quot;201341983&quot;:0,&quot;335559738&quot;:360,&quot;335559739&quot;:360,&quot;335559740&quot;:240}">&nbsp;</span></p>
			</div>
			</div>
			</td>
			</tr>
			<tr style={{height: '47.5938px'}} aria-rowindex={3} role="row">
			<td style={{width: '157.125px', borderWidth: '1px', height: '47.5938px', padding: '6px'}} data-celllook="4369" role="rowheader">
			<div>
			<div>
			<p> <span data-contrast="auto">Alaskan Malamutes</span><span data-ccp-props="{&quot;201341983&quot;:0,&quot;335559738&quot;:360,&quot;335559739&quot;:360,&quot;335559740&quot;:240}">&nbsp;</span></p>
			</div>
			</div>
			</td>
			<td style={{width: '164.875px', borderWidth: '1px', height: '47.5938px', padding: '6px'}} data-celllook="4369">
			<div>
			<div>
			<p><span data-contrast="auto">Dachshunds</span><span data-ccp-props="{&quot;201341983&quot;:0,&quot;335559738&quot;:360,&quot;335559739&quot;:360,&quot;335559740&quot;:240}">&nbsp;</span></p>
			</div>
			</div>
			</td>
			</tr>
			<tr style={{height: '47.5938px'}} aria-rowindex={4} role="row">
			<td style={{width: '157.125px', borderWidth: '1px', height: '47.5938px', padding: '6px'}} data-celllook="4369" role="rowheader">
			<div>
			<div>
			<p> <span data-contrast="auto">Dalmatians</span><span data-ccp-props="{&quot;201341983&quot;:0,&quot;335559738&quot;:360,&quot;335559739&quot;:360,&quot;335559740&quot;:240}">&nbsp;</span></p>
			</div>
			</div>
			</td>
			<td style={{width: '164.875px', borderWidth: '1px', height: '47.5938px', padding: '6px'}} data-celllook="4369">
			<div>
			<div>
			<p><span data-contrast="auto">Australian Shepard dogs</span><span data-ccp-props="{&quot;201341983&quot;:0,&quot;335559738&quot;:360,&quot;335559739&quot;:360,&quot;335559740&quot;:240}">&nbsp;</span></p>
			</div>
			</div>
			</td>
			</tr>
			<tr style={{height: '47.5938px'}} aria-rowindex={5} role="row">
			<td style={{width: '157.125px', borderWidth: '1px', height: '47.5938px', padding: '6px'}} data-celllook="4369" role="rowheader">
			<div>
			<div>
			<p><span data-contrast="auto">Border Collies</span><span data-ccp-props="{&quot;201341983&quot;:0,&quot;335559738&quot;:360,&quot;335559739&quot;:360,&quot;335559740&quot;:240}">&nbsp;</span></p>
			</div>
			</div>
			</td>
			<td style={{width: '164.875px', borderWidth: '1px', height: '47.5938px', padding: '6px'}} data-celllook="4369">
			<div>
			<div>
			<p><span data-contrast="auto">Catahoula Leopard dogs</span><span data-ccp-props="{&quot;201341983&quot;:0,&quot;335559738&quot;:360,&quot;335559739&quot;:360,&quot;335559740&quot;:240}">&nbsp;</span></p>
			</div>
			</div>
			</td>
			</tr>
			<tr style={{height: '47.5938px'}} aria-rowindex={6} role="row">
			<td style={{width: '157.125px', borderWidth: '1px', height: '47.5938px', padding: '6px'}} data-celllook="4369" role="rowheader">
			<div>
			<div>
			<p><span data-contrast="auto">Beagles</span><span data-ccp-props="{&quot;201341983&quot;:0,&quot;335559738&quot;:360,&quot;335559739&quot;:360,&quot;335559740&quot;:240}">&nbsp;</span></p>
			</div>
			</div>
			</td>
			<td style={{width: '164.875px', borderWidth: '1px', height: '47.5938px', padding: '6px'}} data-celllook="4369">
			<div>
			<div>
			<p><span data-contrast="auto">Chihuahuas</span><span data-ccp-props="{&quot;201341983&quot;:0,&quot;335559738&quot;:360,&quot;335559739&quot;:360,&quot;335559740&quot;:240}">&nbsp;</span></p>
			</div>
			</div>
			</td>
			</tr>
			<tr style={{height: '47.5938px'}} aria-rowindex={7} role="row">
			<td style={{width: '157.125px', borderWidth: '1px', height: '47.5938px', padding: '6px'}} data-celllook="4369" role="rowheader">
			<div>
			<div>
			<p><span data-contrast="auto">Shih Tzus</span><span data-ccp-props="{&quot;201341983&quot;:0,&quot;335559738&quot;:360,&quot;335559739&quot;:360,&quot;335559740&quot;:240}">&nbsp;</span></p>
			</div>
			</div>
			</td>
			<td style={{width: '164.875px', borderWidth: '1px', height: '47.5938px', padding: '6px'}} data-celllook="4369">
			<div>
			<div>
			<p><span data-contrast="auto"></span><span data-ccp-props="{&quot;201341983&quot;:0,&quot;335559738&quot;:360,&quot;335559739&quot;:360,&quot;335559740&quot;:240}">&nbsp;</span></p>
			</div>
			</div>
			</td>
			</tr>
			</tbody>
			</table>
			</div>
			</div>
			<div>
			<h2 style={{padding: '1rem 0'}}> <span data-contrast="none">11. Privacy Policy.</span><span>&nbsp;</span></h2>
			</div>
			<div>
			<p><span data-contrast="none">PuppySpot's Privacy Policy governs Customer's visit to the Website and Customer's use of PuppySpot's services. Please review the </span><a rel="noreferrer noopener" target="_blank" href="/privacy"><span data-contrast="none">Privacy Policy</span></a><span data-contrast="none"> to understand PuppySpot's practices, and how PuppySpot may collect, use, share or otherwise disclose information.</span><span>&nbsp;</span></p>
			</div>
			<div>
			<h2 ><span data-contrast="none">12. Consent to Receive Phone Calls and Auto-Dialed Calls.</span><span>&nbsp;</span></h2>
			</div>
			<div>

				<p><span data-contrast="none">
					<span style={{fontSize: '12.0pt', lineHeight: '115%', fontFamily: "'Times New Roman', serif"}}>By</span>
					<span style={{fontSize: '12.0pt', lineHeight: '115%', fontFamily: "'Times New Roman', serif"}}>&nbsp;</span>
					<span style={{fontSize: '12.0pt', lineHeight: '115%', fontFamily: "'Times New Roman', serif"}}>electronically signing this Agreement</span>
					<span style={{fontSize: '12.0pt', lineHeight: '115%', fontFamily: "'Times New Roman', serif"}}>,</span>
					<span style={{fontSize: '12.0pt', lineHeight: '115%', fontFamily: "'Times New Roman', serif"}}> you authorize </span>
					<span style={{fontSize: '12.0pt', lineHeight: '115%', fontFamily: "'Times New Roman', serif"}}>PuppySpot,&nbsp;AKC and </span>
					<span style={{fontSize: '12.0pt', lineHeight: '115%', fontFamily: "'Times New Roman', serif"}}>Third Party Pet, and</span>
					<span style={{fontSize: '12.0pt', lineHeight: '115%', fontFamily: "'Times New Roman', serif"}}>&nbsp;</span>
					<span style={{fontSize: '12.0pt', lineHeight: '115%', fontFamily: "'Times New Roman', serif"}}>our or </span>
					<span style={{fontSize: '12.0pt', lineHeight: '115%', fontFamily: "'Times New Roman', serif"}}>their&nbsp;</span>
					<span style={{fontSize: '12.0pt', lineHeight: '115%', fontFamily: "'Times New Roman', serif"}}>other affiliates to deliver to you, at the telephone number supplied by you to </span>
					<span style={{fontSize: '12.0pt', lineHeight: '115%', fontFamily: "'Times New Roman', serif"}}>PuppySpot</span>
					<span style={{fontSize: '12.0pt', lineHeight: '115%', fontFamily: "'Times New Roman', serif"}}> during your purchase, telemarketing calls</span>
					<span style={{fontSize: '12.0pt', lineHeight: '115%', fontFamily: "'Times New Roman', serif"}}>&nbsp;or text messages</span>
					<span style={{fontSize: '12.0pt', lineHeight: '115%', fontFamily: "'Times New Roman', serif"}}> using an automatic telephone dialing system or an </span>
					<span style={{fontSize: '12.0pt', lineHeight: '115%', fontFamily: "'Times New Roman', serif"}}>artificial</span>
					<span style={{fontSize: '12.0pt', lineHeight: '115%', fontFamily: "'Times New Roman', serif"}}> or prerecorded voice. </span>
					<span style={{fontSize: '12.0pt', lineHeight: '115%', fontFamily: "'Times New Roman', serif"}}>Some of </span>
					<span style={{fontSize: '12.0pt', lineHeight: '115%', fontFamily: "'Times New Roman', serif"}}>these calls </span>
					<span style={{fontSize: '12.0pt', lineHeight: '115%', fontFamily: "'Times New Roman', serif"}}>and/or messages </span>
					<span style={{fontSize: '12.0pt', lineHeight: '115%', fontFamily: "'Times New Roman', serif"}}>will enable us </span>
					<span style={{fontSize: '12.0pt', lineHeight: '115%', fontFamily: "'Times New Roman', serif"}}>and the above affiliates </span>
					<span style={{fontSize: '12.0pt', lineHeight: '115%', fontFamily: "'Times New Roman', serif"}}>to, among other </span>
					<span style={{fontSize: '12.0pt', lineHeight: '115%', fontFamily: "'Times New Roman', serif"}}>things,</span>
					<span style={{fontSize: '12.0pt', lineHeight: '115%', fontFamily: "'Times New Roman', serif"}}> gather the information necessary to finalize any portion of any items purchased and/or</span>
					<span style={{fontSize: '12.0pt', lineHeight: '115%', fontFamily: "'Times New Roman', serif"}}> inform you of products or services that may be available to you.&nbsp;</span>
					<span style={{fontSize: '12.0pt', lineHeight: '115%', fontFamily: "'Times New Roman', serif"}}> You are not required to consent to receive such calls </span>
					<span style={{fontSize: '12.0pt', lineHeight: '115%', fontFamily: "'Times New Roman', serif"}}>and texts&nbsp;</span>
					<span style={{fontSize: '12.0pt', lineHeight: '115%', fontFamily: "'Times New Roman', serif"}}>or agree </span>
					<span style={{fontSize: '12.0pt', lineHeight: '115%', fontFamily: "'Times New Roman', serif"}}>to</span>
					<span style={{fontSize: '12.0pt', lineHeight: '115%', fontFamily: "'Times New Roman', serif"}}> this clause as a condition </span>
					<span style={{fontSize: '12.0pt', lineHeight: '115%', fontFamily: "'Times New Roman', serif"}}>of purchasing</span>
					<span style={{fontSize: '12.0pt', lineHeight: '115%', fontFamily: "'Times New Roman', serif"}}> any property, goods</span>
					<span style={{fontSize: '12.0pt', lineHeight: '115%', fontFamily: "'Times New Roman', serif"}}>,</span>
					<span style={{fontSize: '12.0pt', lineHeight: '115%', fontFamily: "'Times New Roman', serif"}}> or services.</span>
					<span style={{fontSize: '12.0pt', lineHeight: '115%', fontFamily: "'Times New Roman', serif"}}>&nbsp;</span>
					<span style={{fontSize: '12.0pt', lineHeight: '115%', fontFamily: "'Times New Roman', serif"}}> For example, you may contact AKC directly to complete the registration and/or provide it with any information that may be necessary to receive any previously purchased services or products through</span>
					<span style={{fontSize: '12.0pt', lineHeight: '115%', fontFamily: "'Times New Roman', serif"}}> AKC </span>
					<span style={{fontSize: '12.0pt', lineHeight: '115%', fontFamily: "'Times New Roman', serif"}}>yourself</span>
					<span style={{fontSize: '12.0pt', lineHeight: '115%', fontFamily: "'Times New Roman', serif"}}>.&nbsp; If you</span>
					<span style={{fontSize: '12.0pt', lineHeight: '115%', fontFamily: "'Times New Roman', serif"}}> do not agree to receive these calls</span>
					<span style={{fontSize: '12.0pt', lineHeight: '115%', fontFamily: "'Times New Roman', serif"}}> and texts</span>
					<span style={{fontSize: '12.0pt', lineHeight: '115%', fontFamily: "'Times New Roman', serif"}}>, please click </span>
					<a rel="noreferrer noopener" target="_blank" href="mailto:akc@puppyspot.com?subject=Opt-Out%20of%20Marketing%20Calls%20from%20AKC&amp;body=Hello,%20I%20would%20like%20to%20opt%20my%20phone%20number%20(enter%20phone%20number%20here)%20out%20of%20automated%20marketing%20calls%20from%20PuppySpot%20affiliates.">
						<span data-contrast="none">click here</span>
					</a>
					<span data-contrast="none">.</span>
					<span>&nbsp;</span>
					</span>
				</p>
			
			</div>
			<div>
			<h2 ><span data-contrast="none">13. Agreement to Mandatory Individual Arbitration &amp; Class Action Waiver.</span><span>&nbsp;</span></h2>
			</div>
			<div>
			<div>
			<p><span data-contrast="none">PLEASE READ THIS CAREFULLY AS IT AFFECTS YOUR RIGHTS. INSTEAD OF SUING IN COURT, CUSTOMER AND PUPPYSPOT AGREE THAT THE EXCLUSIVE MEANS FOR RESOLVING ANY DISPUTE, CONTROVERSY OR CLAIM ARISING OUT OF, OR RELATING TO, THIS AGREEMENT, OR CUSTOMER'S INTERACTION WITH OR RELATIONSHIP WITH PUPPYSPOT, SHALL BE BINDING ARBITRATION ADMINISTERED BY THE AMERICAN ARBITRATION ASSOCIATION ON AN INDIVIDUAL BASIS. THERE IS NO JUDGE OR JURY IN ARBITRATION, AND COURT REVIEW OF AN ARBITRATION AWARD IS LIMITED. CUSTOMER AGREES THAT, BY ENTERING INTO THIS AGREEMENT, CUSTOMER AND PUPPYSPOT ARE EACH WAIVING THE RIGHT TO A TRIAL BY JURY AND THE RIGHT TO PARTICIPATE IN ANY CLASS OR REPRESENTATIVE ACTION OR OTHER CLASS PROCEEDING. THE CUSTOMER AND PUPPYSPOT FURTHER AGREE AS FOLLOWS:</span><span>&nbsp;</span></p>
			</div>
			<div>
			<ul style={{listStyleType: 'disc'}} role="list">
			<li role="listitem" data-aria-level={1} data-aria-posinset={1} aria-setsize={-1} data-list-defn-props="{&quot;335552541&quot;:1,&quot;335559684&quot;:-2,&quot;335559685&quot;:720,&quot;335559991&quot;:360,&quot;469769226&quot;:&quot;Symbol&quot;,&quot;469769242&quot;:[8226],&quot;469777803&quot;:&quot;left&quot;,&quot;469777804&quot;:&quot;&quot;,&quot;469777815&quot;:&quot;multilevel&quot;}" data-listid="3" data-font="Symbol" data-leveltext="">
			<p><span data-contrast="none">This agreement to arbitrate is intended to be broadly interpreted, and includes, but is not limited to: (1) disputes and claims arising out of, or relating to any aspect of the relationship between Customer and PuppySpot, whether based in breach of contract, breach of any guarantees or warranties, tort, statute, fraud, misrepresentation or any other legal theory; (2) claims that arose before this Agreement or any prior agreement (including, but not limited to, claims relating to advertising); (3) claims that may arise after the termination of Customer's relationship with PuppySpot; and (4) claims that are currently the subject of purported class action litigation in which Customer is not a member of a certified class.</span><span data-ccp-props="{&quot;134233117&quot;:true,&quot;134233118&quot;:true,&quot;201341983&quot;:0,&quot;335559685&quot;:960,&quot;335559737&quot;:240,&quot;335559739&quot;:160,&quot;335559740&quot;:240}">&nbsp;</span></p>
			</li>
			<li role="listitem" data-aria-level={1} data-aria-posinset={2} aria-setsize={-1} data-list-defn-props="{&quot;335552541&quot;:1,&quot;335559684&quot;:-2,&quot;335559685&quot;:720,&quot;335559991&quot;:360,&quot;469769226&quot;:&quot;Symbol&quot;,&quot;469769242&quot;:[8226],&quot;469777803&quot;:&quot;left&quot;,&quot;469777804&quot;:&quot;&quot;,&quot;469777815&quot;:&quot;multilevel&quot;}" data-listid="3" data-font="Symbol" data-leveltext="">
			<p><span data-contrast="none">Customer and PuppySpot hereby agree that the Federal Arbitration Act ("FAA") applies to any arbitration, and governs all questions of whether a dispute is subject to arbitration. Unless Customer and PuppySpot agree otherwise in writing, arbitration shall be: (i) administered by the American Arbitration Association ("AAA"), pursuant to the Consumer Arbitration Rules then in effect (the "AAA's Rules"); and (ii) conducted by a single arbitrator who is licensed to practice law. The AAA's Rules can be found at </span><a rel="noreferrer noopener" target="_blank" href="https://www.adr.org/"><span data-contrast="none">www.adr.org</span></a><span data-contrast="none">.</span><span data-ccp-props="{&quot;134233117&quot;:true,&quot;134233118&quot;:true,&quot;201341983&quot;:0,&quot;335559685&quot;:960,&quot;335559737&quot;:240,&quot;335559739&quot;:160,&quot;335559740&quot;:240}">&nbsp;</span></p>
			</li>
			<li role="listitem" data-aria-level={1} data-aria-posinset={3} aria-setsize={-1} data-list-defn-props="{&quot;335552541&quot;:1,&quot;335559684&quot;:-2,&quot;335559685&quot;:720,&quot;335559991&quot;:360,&quot;469769226&quot;:&quot;Symbol&quot;,&quot;469769242&quot;:[8226],&quot;469777803&quot;:&quot;left&quot;,&quot;469777804&quot;:&quot;&quot;,&quot;469777815&quot;:&quot;multilevel&quot;}" data-listid="3" data-font="Symbol" data-leveltext="">
			<p><span data-contrast="none">THIS AGREEMENT DOES NOT ALLOW CLASS ARBITRATIONS EVEN IF THE PROCEDURES OR RULES OF THE AAA WOULD. RATHER, CUSTOMER AND PUPPYSPOT ARE ENTITLED TO PURSUE ARBITRATION ONLY ON AN INDIVIDUAL BASIS. FURTHER, AND UNLESS CUSTOMER AND PUPPYSPOT AGREE OTHERWISE IN WRITING, THE ARBITRATOR MAY NOT CONSOLIDATE MORE THAN ONE INDIVIDUAL PARTY'S CLAIMS WITH ANY OTHER PARTY'S CLAIMS, AND MAY NOT OTHERWISE PRESIDE OVER ANY FORM OF A REPRESENTATIVE OR COLLECTIVE PROCEEDING.</span><span data-ccp-props="{&quot;134233117&quot;:true,&quot;134233118&quot;:true,&quot;201341983&quot;:0,&quot;335559685&quot;:960,&quot;335559737&quot;:240,&quot;335559739&quot;:160,&quot;335559740&quot;:240}">&nbsp;</span></p>
			</li>
			<li role="listitem" data-aria-level={1} data-aria-posinset={4} aria-setsize={-1} data-list-defn-props="{&quot;335552541&quot;:1,&quot;335559684&quot;:-2,&quot;335559685&quot;:720,&quot;335559991&quot;:360,&quot;469769226&quot;:&quot;Symbol&quot;,&quot;469769242&quot;:[8226],&quot;469777803&quot;:&quot;left&quot;,&quot;469777804&quot;:&quot;&quot;,&quot;469777815&quot;:&quot;multilevel&quot;}" data-listid="3" data-font="Symbol" data-leveltext="">
			<p><span data-contrast="none">Customer and PuppySpot each are responsible for their respective costs relating to counsel, experts and witnesses.</span><span data-ccp-props="{&quot;134233117&quot;:true,&quot;134233118&quot;:true,&quot;201341983&quot;:0,&quot;335559685&quot;:960,&quot;335559737&quot;:240,&quot;335559739&quot;:160,&quot;335559740&quot;:240}">&nbsp;</span></p>
			</li>
			</ul>
			</div>
			</div>
			<div>
			<div>
			<ul style={{listStyleType: 'disc'}} role="list">
			<li role="listitem" data-aria-level={1} data-aria-posinset={1} aria-setsize={-1} data-list-defn-props="{&quot;335552541&quot;:1,&quot;335559684&quot;:-2,&quot;335559685&quot;:720,&quot;335559991&quot;:360,&quot;469769226&quot;:&quot;Symbol&quot;,&quot;469769242&quot;:[8226],&quot;469777803&quot;:&quot;left&quot;,&quot;469777804&quot;:&quot;&quot;,&quot;469777815&quot;:&quot;multilevel&quot;}" data-listid="3" data-font="Symbol" data-leveltext="">
			<p> <span data-contrast="none">This arbitration agreement does not preclude the Customer or PuppySpot from bringing issues to the attention of federal, state or local agencies. Such agencies can, if the law allows, seek relief on a party's behalf. In addition, and notwithstanding the other provisions of this arbitration agreement, either party may bring an individual action in small claims court.</span><span data-ccp-props="{&quot;134233117&quot;:true,&quot;134233118&quot;:true,&quot;201341983&quot;:0,&quot;335559685&quot;:960,&quot;335559737&quot;:240,&quot;335559739&quot;:160,&quot;335559740&quot;:240}">&nbsp;</span></p>
			</li>
			<li role="listitem" data-aria-level={1} data-aria-posinset={2} aria-setsize={-1} data-list-defn-props="{&quot;335552541&quot;:1,&quot;335559684&quot;:-2,&quot;335559685&quot;:720,&quot;335559991&quot;:360,&quot;469769226&quot;:&quot;Symbol&quot;,&quot;469769242&quot;:[8226],&quot;469777803&quot;:&quot;left&quot;,&quot;469777804&quot;:&quot;&quot;,&quot;469777815&quot;:&quot;multilevel&quot;}" data-listid="3" data-font="Symbol" data-leveltext="">
			<p> <span data-contrast="none">If Customer or PuppySpot fails to comply with this arbitration provision, said breaching party shall be liable for the costs and attorneys' fees incurred by the other party in enforcing compliance with the arbitration agreement.</span><span data-ccp-props="{&quot;134233117&quot;:true,&quot;134233118&quot;:true,&quot;201341983&quot;:0,&quot;335559685&quot;:960,&quot;335559737&quot;:240,&quot;335559739&quot;:160,&quot;335559740&quot;:240}">&nbsp;</span></p>
			</li>
			<li role="listitem" data-aria-level={1} data-aria-posinset={3} aria-setsize={-1} data-list-defn-props="{&quot;335552541&quot;:1,&quot;335559684&quot;:-2,&quot;335559685&quot;:720,&quot;335559991&quot;:360,&quot;469769226&quot;:&quot;Symbol&quot;,&quot;469769242&quot;:[8226],&quot;469777803&quot;:&quot;left&quot;,&quot;469777804&quot;:&quot;&quot;,&quot;469777815&quot;:&quot;multilevel&quot;}" data-listid="3" data-font="Symbol" data-leveltext="">
			<p> <span data-contrast="none">Unless the AAA arbitrator rules otherwise, all claims or counterclaims shall be resolved by the submission of documents only / desk arbitration (see R-29 of the AAA's Rules). Any party, however, may ask for a hearing. The arbitrator also may decide that a face-to-face hearing is necessary. Any hearing, however, that is not held by telephone, shall take place in Broward County, Florida, unless the AAA arbitrator decides otherwise.</span><span data-ccp-props="{&quot;134233117&quot;:true,&quot;134233118&quot;:true,&quot;201341983&quot;:0,&quot;335559685&quot;:960,&quot;335559737&quot;:240,&quot;335559739&quot;:160,&quot;335559740&quot;:240}">&nbsp;</span></p>
			</li>
			<li role="listitem" data-aria-level={1} data-aria-posinset={4} aria-setsize={-1} data-list-defn-props="{&quot;335552541&quot;:1,&quot;335559684&quot;:-2,&quot;335559685&quot;:720,&quot;335559991&quot;:360,&quot;469769226&quot;:&quot;Symbol&quot;,&quot;469769242&quot;:[8226],&quot;469777803&quot;:&quot;left&quot;,&quot;469777804&quot;:&quot;&quot;,&quot;469777815&quot;:&quot;multilevel&quot;}" data-listid="3" data-font="Symbol" data-leveltext="">
			<p><span data-contrast="none">Small Claims Option: You may also litigate any dispute in Small Claims Court in Broward County in the State of Florida. if your claim meets all requirements to be heard in the small claims court. You can learn more about the Small Claims Court in the County of Broward, </span><a rel="noreferrer noopener" target="_blank" href="http://www.browardclerk.org/ClerkWebsite/BCCOC2/faqcountycivil.aspx#claim1"><span data-contrast="none">click here</span></a><span data-contrast="none">. However, if you initiate a Small Claims case, you are responsible for all your court costs.</span><span data-ccp-props="{&quot;134233117&quot;:true,&quot;134233118&quot;:true,&quot;201341983&quot;:0,&quot;335559685&quot;:960,&quot;335559737&quot;:240,&quot;335559739&quot;:160,&quot;335559740&quot;:240}">&nbsp;</span></p>
			</li>
			<li role="listitem" data-aria-level={1} data-aria-posinset={5} aria-setsize={-1} data-list-defn-props="{&quot;335552541&quot;:1,&quot;335559684&quot;:-2,&quot;335559685&quot;:720,&quot;335559991&quot;:360,&quot;469769226&quot;:&quot;Symbol&quot;,&quot;469769242&quot;:[8226],&quot;469777803&quot;:&quot;left&quot;,&quot;469777804&quot;:&quot;&quot;,&quot;469777815&quot;:&quot;multilevel&quot;}" data-listid="3" data-font="Symbol" data-leveltext="">
			<p><span data-contrast="none">Any proceeding to enforce this arbitration agreement, including any proceeding to confirm, modify, or vacate an arbitration award, may be commenced in any court of competent jurisdiction. In the event that this arbitration agreement is for any reason held to be unenforceable, any litigation against PuppySpot (except for small-claims court actions) may be commenced only in the federal or state courts located in Broward County, Florida. You hereby irrevocably consent to the jurisdiction of those courts for such purposes.</span><span data-ccp-props="{&quot;134233117&quot;:true,&quot;134233118&quot;:true,&quot;201341983&quot;:0,&quot;335559685&quot;:960,&quot;335559737&quot;:240,&quot;335559739&quot;:160,&quot;335559740&quot;:240}">&nbsp;</span></p>
			</li>
			</ul>
			</div>
			</div>
			<div>
			<h2 style={{padding: '1rem 0'}}>  <span data-contrast="none">14. Choice of Law.</span><span>&nbsp;</span></h2>
			</div>
			<div>
			<p><span data-contrast="none">The Agreement, and any claim, controversy or dispute arising under or related to the Agreement, the relationship of the parties, and/or the interpretation and enforcement of the rights and duties of the parties, shall be governed by and construed in accordance with the laws of the State of Florida, without giving effect to its conflict of law provisions that would cause the application of the laws of any other jurisdiction.</span><span>&nbsp;</span></p>
			</div>
			<div>
			<h2 style={{padding: '1rem 0'}}>  <span data-contrast="none">15. Severability.</span><span>&nbsp;</span></h2>
			</div>
			<div>
			<p><span data-contrast="none">If any provision, or provisions, of this Agreement is held to be illegal, invalid or unenforceable under applicable law by a court of competent jurisdiction, the validity, legality and enforceability of the remaining provisions shall continue in full force and effect and shall not in any way be affected or impaired thereby.</span><span>&nbsp;</span></p>
			</div>
			<div>
			<h2 style={{padding: '1rem 0'}}>  <span data-contrast="none">16. Entire Agreement.</span><span>&nbsp;</span></h2>
			</div>
			<div>
			<p><span data-contrast="none">This Agreement represents the entire agreement between the Parties and no other terms or conditions shall be applicable to this sale.</span><span>&nbsp;</span><span data-contrast="auto"></span></p>
			</div>
			    </div>
			</div>
  );
}

export default TermsAndConditionsOfSaleContainer;
